import React from 'react';
import PropTypes from 'prop-types';
import CartIcon from '@tradera/blueprint/theme/icons2/cart.svg?jsx';
import { useUrlLocalizer } from 'tradera-lang/translate';

const CartLink = ({ formattedCartItems, cartSum, transparentHeader }) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const cartUrl = toLocalizedUrl('/shopping/cart');
    return (
        <div>
            <a
                href={cartUrl}
                aria-label="Mitt Tradera"
                className={`btn slim-header__cart-link slim-header__link-spacing pr-xl-3 d-flex position-relative align-items-center ${
                    transparentHeader
                        ? 'btn-transparent-header'
                        : 'btn-link text-dark'
                }`}
                data-ga-category="Top navigation"
                data-ga-action="Cart"
                data-ga-label="Link - Cart with items from NavBar">
                <span className="slim-header__notification-cart badge badge-primary badge-pill-round badge-pill-round-sm">
                    {formattedCartItems}
                </span>
                <div className="btn btn-branded btn-round d-flex align-items-center justify-content-center">
                    <CartIcon
                        className={`icon icon-md ${
                            transparentHeader ? 'icon-dark' : ''
                        }`}
                    />
                </div>
                <div className="slim-header__link-text d-none d-xl-flex flex-column pl-xl-1">
                    <span className="text-left">{cartSum} kr</span>
                </div>
            </a>
        </div>
    );
};

CartLink.propTypes = {
    formattedCartItems: PropTypes.number,
    cartSum: PropTypes.number
};

export default React.memo(CartLink);
